__turbopack_context__.v({
  "calculateBar": "costCalculatorClient-module-scss-module__oCuAWW__calculateBar",
  "calculateButton": "costCalculatorClient-module-scss-module__oCuAWW__calculateButton",
  "calculator": "costCalculatorClient-module-scss-module__oCuAWW__calculator",
  "calculatorCard": "costCalculatorClient-module-scss-module__oCuAWW__calculatorCard",
  "callToAction": "costCalculatorClient-module-scss-module__oCuAWW__callToAction",
  "callToActionWrap": "costCalculatorClient-module-scss-module__oCuAWW__callToActionWrap",
  "container": "costCalculatorClient-module-scss-module__oCuAWW__container",
  "resultsAnchor": "costCalculatorClient-module-scss-module__oCuAWW__resultsAnchor",
  "scrollButton": "costCalculatorClient-module-scss-module__oCuAWW__scrollButton",
  "scrollButtonRow": "costCalculatorClient-module-scss-module__oCuAWW__scrollButtonRow",
  "sectionsAnchor": "costCalculatorClient-module-scss-module__oCuAWW__sectionsAnchor",
});
